import { render } from "./Premium.vue?vue&type=template&id=4605628c&scoped=true"
import script from "./Premium.vue?vue&type=script&lang=js"
export * from "./Premium.vue?vue&type=script&lang=js"

import "./Premium.vue?vue&type=style&index=0&id=4605628c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4605628c"

export default script